// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#doses {
    position: relative;
    height: 100vh;
    height: 100dvh;
    display: flex;
    flex-direction: column;
}

.language-toggle {
    background-color: transparent;
    border: 2px solid var(--main-foreground-color);
    border-radius: 2rem;
    color: var(--main-foreground-color);
    padding: 0.5rem;
    margin-inline-start: auto;
    margin-inline-end: 1rem;
    font-size: 1.2rem;
    width: 3rem;
    height: 3rem;
}

#doses header {
    flex: 0 0 auto;
    width: 100%;
    min-height: 5rem;
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    gap: 0.5rem;
    padding: calc(0.5rem + env(safe-area-inset-top)) 0.5rem 0.5rem 1.5rem;
    box-sizing: border-box;
    background-color: transparent;
    color: var(--secondary-color);
    z-index: 1;
}

#doses header h1 {
    font-size: 1.75rem;
    margin: 0;
}

#doses header .logo {
    height: 2.5rem;
}

#doses .entries {
    display: flex;
    flex-direction: column;
    justify-content: safe flex-end;
    flex: 1 1 auto;
    overflow-x: hidden;
    overflow-y: scroll;
    padding: 2rem 0.5rem 2rem;
}

#doses .entry-group.muted {
    opacity: 0.5;
}

#doses footer {
    flex: 0 0 auto;
    width: 100%;
    min-height: 5rem;
    display: flex;
    position: relative;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-end;
    /* Bottom padding matches the add-dose FAB's bottom offset so the text lines up with it. */
    padding: 1rem 0.5rem calc(1.5rem + env(safe-area-inset-bottom)) 2.5rem;
    box-sizing: border-box;
    background-color: var(--main-background-color);
    z-index: 1;
}

.no-doses-prompt {
    color: var(--secondary-color);
    font-size: 1.5rem;
    display: flex;
    align-items: center;
}

.add-new-dose {
    background-color: transparent;
    border: none;
    color: var(--main-foreground-color);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 0;
    border: 1px solid var(--main-foreground-color);
    border-radius: 50%;
}

.add-new-dose:hover {
    cursor: pointer;
}

.add-new-dose .plus {
    position: relative;
    width: 2.1rem;
    height: 2.1rem;
    font-size: 0;
}

.add-new-dose .plus::before,
.add-new-dose .plus::after {
    content: '';
    position: absolute;
    background-color: var(--main-foreground-color);
    border-radius: 1px;
}

.add-new-dose .plus::before {
    width: 100%;
    height: 2px;
    top: 50%;
    left: 0;
    transform: translateY(-50%);
}

.add-new-dose .plus::after {
    width: 2px;
    height: 100%;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
}

.options-button {
    background-color: transparent;
    border: none;
    color: var(--main-foreground-color);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: calc(1rem + env(safe-area-inset-top));
    right: 1.5rem;
    height: 3rem;
    width: 3rem;
    cursor: pointer;
    z-index: 2;
}

.scroll-to-bottom-button {
    background-color: transparent;
    border: 1px solid var(--main-foreground-color);
    border-radius: 50%;
    color: var(--secondary-color);
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: calc(6rem + env(safe-area-inset-top));
    right: 1.5rem;
    height: 3rem;
    width: 3rem;
    cursor: pointer;
    z-index: 2;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Home.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;IAC9C,mBAAmB;IACnB,mCAAmC;IACnC,eAAe;IACf,yBAAyB;IACzB,uBAAuB;IACvB,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,WAAW;IACX,qEAAqE;IACrE,sBAAsB;IACtB,6BAA6B;IAC7B,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,2BAA2B;IAC3B,qBAAqB;IACrB,0FAA0F;IAC1F,sEAAsE;IACtE,sBAAsB;IACtB,8CAA8C;IAC9C,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,UAAU;IACV,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,cAAc;IACd,YAAY;AAChB;;AAEA;;IAEI,WAAW;IACX,kBAAkB;IAClB,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,QAAQ;IACR,OAAO;IACP,2BAA2B;AAC/B;;AAEA;IACI,UAAU;IACV,YAAY;IACZ,MAAM;IACN,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,mCAAmC;IACnC,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;AACd;;AAEA;IACI,6BAA6B;IAC7B,8CAA8C;IAC9C,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,aAAa;IACb,YAAY;IACZ,WAAW;IACX,eAAe;IACf,UAAU;AACd","sourcesContent":["#doses {\n    position: relative;\n    height: 100vh;\n    height: 100dvh;\n    display: flex;\n    flex-direction: column;\n}\n\n.language-toggle {\n    background-color: transparent;\n    border: 2px solid var(--main-foreground-color);\n    border-radius: 2rem;\n    color: var(--main-foreground-color);\n    padding: 0.5rem;\n    margin-inline-start: auto;\n    margin-inline-end: 1rem;\n    font-size: 1.2rem;\n    width: 3rem;\n    height: 3rem;\n}\n\n#doses header {\n    flex: 0 0 auto;\n    width: 100%;\n    min-height: 5rem;\n    display: flex;\n    position: relative;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: center;\n    gap: 0.5rem;\n    padding: calc(0.5rem + env(safe-area-inset-top)) 0.5rem 0.5rem 1.5rem;\n    box-sizing: border-box;\n    background-color: transparent;\n    color: var(--secondary-color);\n    z-index: 1;\n}\n\n#doses header h1 {\n    font-size: 1.75rem;\n    margin: 0;\n}\n\n#doses header .logo {\n    height: 2.5rem;\n}\n\n#doses .entries {\n    display: flex;\n    flex-direction: column;\n    justify-content: safe flex-end;\n    flex: 1 1 auto;\n    overflow-x: hidden;\n    overflow-y: scroll;\n    padding: 2rem 0.5rem 2rem;\n}\n\n#doses .entry-group.muted {\n    opacity: 0.5;\n}\n\n#doses footer {\n    flex: 0 0 auto;\n    width: 100%;\n    min-height: 5rem;\n    display: flex;\n    position: relative;\n    flex-direction: row;\n    justify-content: flex-start;\n    align-items: flex-end;\n    /* Bottom padding matches the add-dose FAB's bottom offset so the text lines up with it. */\n    padding: 1rem 0.5rem calc(1.5rem + env(safe-area-inset-bottom)) 2.5rem;\n    box-sizing: border-box;\n    background-color: var(--main-background-color);\n    z-index: 1;\n}\n\n.no-doses-prompt {\n    color: var(--secondary-color);\n    font-size: 1.5rem;\n    display: flex;\n    align-items: center;\n}\n\n.add-new-dose {\n    background-color: transparent;\n    border: none;\n    color: var(--main-foreground-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    padding: 0;\n    border: 1px solid var(--main-foreground-color);\n    border-radius: 50%;\n}\n\n.add-new-dose:hover {\n    cursor: pointer;\n}\n\n.add-new-dose .plus {\n    position: relative;\n    width: 2.1rem;\n    height: 2.1rem;\n    font-size: 0;\n}\n\n.add-new-dose .plus::before,\n.add-new-dose .plus::after {\n    content: '';\n    position: absolute;\n    background-color: var(--main-foreground-color);\n    border-radius: 1px;\n}\n\n.add-new-dose .plus::before {\n    width: 100%;\n    height: 2px;\n    top: 50%;\n    left: 0;\n    transform: translateY(-50%);\n}\n\n.add-new-dose .plus::after {\n    width: 2px;\n    height: 100%;\n    top: 0;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.options-button {\n    background-color: transparent;\n    border: none;\n    color: var(--main-foreground-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: calc(1rem + env(safe-area-inset-top));\n    right: 1.5rem;\n    height: 3rem;\n    width: 3rem;\n    cursor: pointer;\n    z-index: 2;\n}\n\n.scroll-to-bottom-button {\n    background-color: transparent;\n    border: 1px solid var(--main-foreground-color);\n    border-radius: 50%;\n    color: var(--secondary-color);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    position: absolute;\n    top: calc(6rem + env(safe-area-inset-top));\n    right: 1.5rem;\n    height: 3rem;\n    width: 3rem;\n    cursor: pointer;\n    z-index: 2;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
